import styled from "styled-components"
import dmws_logo from "../Assets/dmwslogo.png"
import chakkra_img from "../Assets/dchakra.png"
import {keyframes} from "styled-components"
import { ExtraSmall,Small} from "../Responsive"
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useEffect, useState } from "react"
import CloseIcon from '@mui/icons-material/Close';
import { Link } from "react-router-dom"
// Styled Components

const ChakkraSpinning=keyframes`
from{
    transform: rotate(0deg);
},
to{
    transform: rotate(360deg);
}
`
const Container=styled.div`
  //  background-color: yellow;
   display: flex;
   align-items:center;
   justify-content:center;
   height: 15vh;
   margin:2vh auto;
   width: 90vw;
   ${ExtraSmall({flexDirection:"row-reverse",
   backgroundColor:"#F8F7F0",
   height:"10vh",
   marginTop:"1vh",
   position:"fixed",
   padding:'20px',
   top:"-0.5rem",
   width:'100%',
   zIndex:999
})};
   ${Small({flexDirection:"row-reverse",
   height:"8vh"

})}
`
const Logo = styled.div`
// background-color: green;
display: flex;
align-item:center;
height: inherit;
width:10%;
${ExtraSmall({
    display:"none",
    justifyContent:"flex-end",
    
})};
${Small({display: "none"})}

`
const LogoImg=styled.img`
cursor:pointer;
 object-fit:contain;
 height: auto;
 width: 100px;
`
const MenuContainer=styled.div`
// background-color: pink;
display:flex;
flex-direction: column;
align-items:Center;
justify-content:center;
gap: 10px;
height: inherit;
width:80%; 
`
const DmwsTitle=styled.h1`
margin-left: 70px;
${ExtraSmall({
 fontSize:"17px",
 fontWeight:"500",
 marginLeft:"1%",
})};
${Small({
    fontSize:"1.4rem",
    marginLeft:"2%"

})}

`
const MenuList=styled.ul`
display: flex;
align-items:center;
justify-content: space-between;
list-style:none;
${ExtraSmall({display:"none"})};
${Small({display: "none"})}
`
const MenutItem=styled.li`
cursor: pointer;
padding-left: 70px;
&:hover{
    color:#FFF500;
}
`
const DonateButton=styled.button`
border: 1px solid #FFF500;
background-color: transparent;
border-radius: 26px;
padding: 10px 30px;
cursor: pointer;
&:hover{
   background-color: #FFF500;
}
`
const Chakkra=styled.div`
// background-color: blue; 
cursor: pointer;
display:flex;
align-item:center;
justify-content: flex-end;
height: inherit;
width:10%; 
${ExtraSmall({
    justifyContent:"flex-start",
    height: "4.5vh",
    marginLeft:"-10%",
})};
${Small({
    height:"6vh",
    justifyContent:"flex-start",
    marginLeft:"-10%"
})}

`
const ChakkraImg = styled.img`
animation: ${ChakkraSpinning} 30s linear infinite;
object-fit:contain;
height: auto;
width: 90px;
`
const Hamburger=styled.div`
//  background-color: green;
 display: none;
 align-items:Center;
 justify-content: flex-end;
 height: inherit;
 margin-right:-10%;
 width: 10%;
 ${ExtraSmall({display:"flex"})};
 ${Small({display:"flex"})}
`
const MobileMenu=styled.div`
 background-color: white;
 box-shadow: 0px 0px 1px 1px whitesmoke;
 border-radius: 6px;
 display: none;
 align-items: center;
 justify-content: center;
 height: 40vh;
 float:right;
 margin-top: -6%;
 margin-right: 5.5%;
 transform: translateX(200px);
 transition: all 0.5s ease;
 width: 40vw;
 z-index: 999;
 ${ExtraSmall({marginTop:"-2%",zIndex:"999",position:'fixed',right:'0.5rem',top:'3.5rem'})};
 ${Small({marginTop:"-2%",position:'absolute',right:'0px'})}
`
const SubMenuList=styled.ul`
display: flex;
justify-content: center;
flex-direction: column;
gap: 40px;
list-style:none
`
const SubMenuListItem=styled.li`
cursor: pointer;
`
const DonateContainer=styled.div`
background-color:#F8F7F0;
border:0.5px solid gray;
border-radius: 6px;
display:none;
flex-direction:column;
align-items:center;
justify-content:Center;
gap: 20px;
height: 70vh;
position:absolute;
right: 31vw;
margin:10px auto;
width: 40vw;
z-index:999;
${ExtraSmall({width:"88vw",height:"60vh",position:"absolute",top: "10vh",left:"1.5rem",zIndex:"2"})}
${Small({width:"80vw",zIndex:"2"})}
`
const Para=styled.p`
`
const CloseDonate=styled.div`
// background-color:yellow;
cursor:pointer;
display:flex;
align-items:center;
justify-content:center;
height:30px;
position:absolute;
top:5px;
right:5px;
width: 30px;
`

const Navbar=()=>{

    const [closeMenuIcon,setCloseMenuIcon]=useState(false);



  const donatePageFun=()=>{
    if(document.getElementById("donatePage").style.display==="flex"){
      document.getElementById("donatePage").style.display="none"
    }else{
      document.getElementById("donatePage").style.display="flex"
      document.getElementById("mobileMenu").style.display="none"
      setCloseMenuIcon(false)     
    }
  }
  const closeDonatePageFun=()=>{
    document.getElementById("donatePage").style.display="none"
  }

    const mobileMenuFun=(props)=>{
          if(props==="close"){
            setCloseMenuIcon(false)
            document.getElementById("mobileMenu").style.display="none";
            document.getElementById("mobileMenu").style.transform="translate(200px)"
            
          }else if(props==="open"){
            setCloseMenuIcon(true)
            document.getElementById("mobileMenu").style.display="flex";
            document.getElementById("mobileMenu").style.transform="translate(0)"
          }else{
          
            document.getElementById("mobileMenu").style.display="none";
            document.getElementById("mobileMenu").style.transform="translate(200px)"
          }
    }
    useEffect(()=>{
      if(document.getElementById("mobileMenu").style.display==="flex"){
        document.getElementById("mobileMenu").style.display="none"
      }
    },[])
    return(
    <>
     <Container>
        <Logo>
            <LogoImg src={dmws_logo} alt="DMWS Logo"/>
        </Logo>
        <Hamburger>  
               {closeMenuIcon?<CloseRoundedIcon onClick={()=>mobileMenuFun("close")}/>:<MenuRoundedIcon onClick={()=>mobileMenuFun("open")}/>}         
        </Hamburger>
        <MenuContainer>
          <DmwsTitle>Dhamma Metta Welfare Society</DmwsTitle>
          <MenuList>
            <MenutItem><Link to="/">Home</Link></MenutItem>
            <MenutItem><Link to="/work">Work</Link></MenutItem>
            <MenutItem><Link to="/contact">Contact</Link></MenutItem>
            <MenutItem>
                <DonateButton id="donateBtn" onClick={donatePageFun}>Donate</DonateButton>
            </MenutItem>
          </MenuList>
        </MenuContainer>
        <Chakkra>
            <ChakkraImg src={chakkra_img} alt="Chakkra"/>
        </Chakkra>
     </Container>
      <MobileMenu id="mobileMenu">
        <SubMenuList>
            <SubMenuListItem><Link to="/">Home</Link></SubMenuListItem>
            <SubMenuListItem><Link to="/work">Work</Link></SubMenuListItem>
            <SubMenuListItem><Link to="/contact">Contact</Link></SubMenuListItem>
            <SubMenuListItem> <DonateButton  onClick={donatePageFun}>Donate</DonateButton></SubMenuListItem>
        </SubMenuList>
      </MobileMenu>
      <DonateContainer id="donatePage">
        <Para>
        Bank Name: Union Bank Of India
        </Para>
        <Para>
        Account Number: 344501010051630
        </Para>
        <Para>
        IFSC Code: UBIN0534455
        </Para>
        <Para>
        Branch: Aurangabad
        </Para>
        <Para>
        Mobile Number: +91-83981918939<br></br>
        </Para>
        <CloseDonate><CloseIcon onClick={closeDonatePageFun}/></CloseDonate>
      </DonateContainer>
    </>
    )
}
export default Navbar